import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { AttachmentModel } from '@fc-vehicles/service/attachment-model';

@Component({
  selector: 'fc-media-view-video',
  template: `
    <video
      [src]="file().original"
      (loadedmetadata)="fileLoaded.emit(true)"
      controls
      autoplay
      class="max-h-full"
    ></video>
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }

      video {
        max-width: 100%;
        max-height: 100%;
      }
    `,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaViewVideoComponent {
  file = input<AttachmentModel>();
  fileLoaded = output<boolean>();
}
